import React from 'react';
import { useVarValues } from './varValuesContext';

type Props = {
  variables: string[];
  loading: boolean;
  status: string;
  dirty: boolean;
  onPreview: () => void;
};

export default function DataInputs({ variables, loading, status, dirty, onPreview }: Props) {
  const { values, setVar } = useVarValues();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', padding: '0.75rem',
                  border: '1px solid #e2e8f0', borderRadius: 8, background: '#f7fafc' }}>
      {variables.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
          {variables.map((name) => (
            <label key={name} style={{ fontSize: 12, color: '#4a5568', display: 'flex', flexDirection: 'column', gap: 2 }}>
              {name}{name === 'slug' ? ' (challenge slug)' : ''}
              <input
                value={values[name] ?? ''}
                onChange={(e) => setVar(name, e.target.value)}
                placeholder={name === 'slug' ? 'e.g. my-challenge' : name}
                style={{ padding: '0.35rem 0.5rem', border: '1px solid #cbd5e0', borderRadius: 4, fontSize: 13, minWidth: 160 }}
              />
            </label>
          ))}
        </div>
      ) : (
        <span style={{ fontSize: 12, color: '#a0aec0' }}>No query variables — renders with FAKE_DATA.</span>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <button
          onClick={onPreview}
          disabled={loading}
          style={{ padding: '0.5rem 1rem', borderRadius: 4, border: 'none',
                   background: loading ? '#a0aec0' : '#4299e1', color: 'white',
                   fontWeight: 600, fontSize: 14, cursor: loading ? 'default' : 'pointer' }}
        >
          {loading ? 'Loading…' : '▷ Preview'}
        </button>
        <span style={{ fontSize: 12, color: dirty ? '#d69e2e' : '#718096' }}>
          {dirty ? 'code changed — click Preview to update' : status}
        </span>
      </div>
    </div>
  );
}
